import Vue from "vue";

export const login = ({ dispatch }, params) => {
  Vue.http.post(Vue.http.options.root + "/api/Token", params).then(function (response) {
    dispatch("LOGGED_IN", response.data.access_token, response.data.userHash);
    var returnUrl = window.localStorage.getItem("returnUrl");
    if (!returnUrl) {
      returnUrl = window.location.href;
    }
    document.location = Vue.http.options.profilerUrl + "/services/sso.aspx?hash=" + response.data.userHash + "&ret=" + returnUrl;
  }, function (response) {
    dispatch("LOGGING_FAILURE", response.data);
  });
};

export const loginFailureReset = ({ dispatch }) => {
  dispatch("LOGGING_FAILURE_RESET");
};



// WEBPACK FOOTER //
// ./src/views/login/LoginActions.js